document.addEventListener("DOMContentLoaded", function() {
// Select all buttons with class "quick-add-open"
var openButtons = document.querySelectorAll('.quick-add-open');
// Select all buttons with class "quick-add-modal-close"
var closeButtons = document.querySelectorAll('.quick-add-modal-close');
var htmlTag = document.querySelector('html');
var bodyTag = document.querySelector('body');

// Add event listeners for open buttons
openButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        // Add 'active' class to HTML tag
        htmlTag.classList.add('overflow-hidden');
        bodyTag.classList.remove('overflow-hidden');
    });
});

// Add event listeners for close buttons
closeButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        // Remove 'active' class from HTML tag
        htmlTag.classList.remove('overflow-hidden');
      
    });
});
});